
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[property_ref]",
      function () {
        return require("private-next-pages/properties/[property_ref].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[property_ref]"])
      });
    }
  